<template>
    <div>

        <div v-if="Object.keys(aluno).length !== 0 && !loadingInfoAluno">

            <div>
                <el-row :gutter="10" class="">
                    <el-col :xs="24" :sm="16" :md="16">
                        <dl>
                            <dt>NOME</dt>
                            <dd>
                                {{ aluno.nome }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>Nr. MATRÍCULA</dt>
                            <dd>
                                {{ (aluno.num_matricula) ? aluno.num_matricula : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10" class="">
                    <el-col :xs="24" :sm="12" :md="12">
                        <dl>
                            <dt>NOME CENSO</dt>
                            <dd>
                                {{ aluno.nome_aluno_censo }}
                            </dd>
                        </dl>
                    </el-col>                
                    <el-col :xs="24" :sm="12" :md="12">
                        <dl>
                            <dt>NOME SOCIAL</dt>
                            <dd>
                                {{ aluno.nome_social_aluno }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>SEXO</dt>
                            <dd>
                                {{ $CONSTANTS.SEXO[aluno.sexo] }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>Dt. NASCIMENTO</dt>
                            <dd>
                                {{ (aluno.data_nascimento) ? $moment(aluno.data_nascimento).format('DD/MM/YYYY') : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>COR</dt>
                            <dd>
                                {{ (aluno.cor || aluno.cor === 0) ? ($store.getters.mapaRacaCor[aluno.cor] || '-') : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>CPF</dt>
                            <dd>
                                {{ (aluno.cpf) ? aluno.cpf : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="16">
                        <dl>
                            <dt>RG</dt>
                            <dd>
                                <template v-if="aluno.rg">
                                {{ (aluno.rg) ? aluno.rg : '' }}
                                {{ (aluno.data_emissao_rg) ? ' - (' + $moment(aluno.data_emissao_rg).format('DD/MM/YYYY') + ') - ' : '' }}
                                {{ (aluno.orgao_emissor_rg) ? '(' + aluno.orgao_emissor_rg + ') - ' : '' }}
                                {{ (aluno.uf_rg) ? '(' + aluno.uf_rg + ')' : '' }}
                                </template>
                                <template v-else>-</template>
                            </dd>
                        </dl>
                    </el-col>

                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>NIS</dt>
                            <dd>
                                {{ (aluno.nis) ? aluno.nis : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>CARTÃO SUS</dt>
                            <dd>
                                {{ (aluno.cartao_sus) ? aluno.cartao_sus : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>INEP</dt>
                            <dd>
                                {{ (aluno.inep) ? aluno.inep : '-' }}
                            </dd>
                        </dl>
                    </el-col>

                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16" :md="16">
                        <dl>
                            <dt>REGISTRO ANTIGO</dt>
                            <dd>
                                <template v-if="aluno.reg_nasc_antigo_registro">
                                    NÚMERO: {{ (aluno.reg_nasc_antigo_registro) ? aluno.reg_nasc_antigo_registro : '-' }} -
                                    (FOLHA: {{ (aluno.reg_nasc_antigo_folha) ? aluno.reg_nasc_antigo_folha : '-' }}) -
                                    (LIVRO: {{ (aluno.reg_nasc_antigo_livro) ? aluno.reg_nasc_antigo_livro : '-' }}) -
                                    (EMISSAO: {{ (aluno.reg_nasc_antigo_folha ? $moment(aluno.data_emissao_registro).format('DD/MM/YYYY') : '-') }})
                                </template>
                                <template v-else>-</template>
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>REGISTRO NOVO</dt>
                            <dd>
                                {{ (aluno.registro_nasc_novo) ? aluno.registro_nasc_novo : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>FILIAÇÃO 1</dt>
                            <dd>
                                {{ (aluno.mae) ? aluno.mae : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>FILIAÇÃO 2</dt>
                            <dd>
                                {{ (aluno.pai) ? aluno.pai : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>RESPONSÁVEL</dt>
                            <dd>
                                {{ (aluno.responsavel) ? aluno.responsavel : '-' }}
                                {{ (aluno.parentesco) ? ' (' + aluno.parentesco + ')': '' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>ENDEREÇO</dt>
                            <dd style="text-transform: uppercase;">
                                {{ aluno.logradouro }}
                                {{ aluno.numero }}
                                {{ aluno.bairro }}
                                {{ aluno.cep }}
                                {{ aluno.complemento }}
                                {{ aluno.localizacao_zona ? '(' + $CONSTANTS.LOCALIZACAO_ZONA[aluno.localizacao_zona] + ')' : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>MUNIC. NASC.</dt>
                            <dd>
                                {{ (aluno.municipio_nascimento) ? aluno.municipio_nascimento.nome : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>TELEFONE</dt>
                            <dd>
                                {{ (aluno.telefone) ? aluno.telefone : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>CELULAR</dt>
                            <dd>
                                {{ (aluno.celular) ? aluno.celular : '-' }}
                                {{ (aluno.celular_outro) ? aluno.celular_outro : '' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>DADOS DE SAÚDE</dt>
                            <dd>
                                <span v-if="aluno.deficiencias.length > 0">
                                    <b class="u-mr-10">DEFICIÊNCIA (S):</b>
                                    <template v-for="(item, i) in aluno.deficiencias">
                                        <span :key="i" class="u-mr-10" style="text-transform: uppercase;">{{ item.nome }} {{ item.cid10 ? '- (CID: ' + item.cid10 + ')' : '' }} </span>
                                    </template>
                                </span>

                                <span v-if="aluno.alergias.length > 0">
                                    <b class="u-mr-10">ALERGIA (S):</b>
                                    <template v-for="(item, j) in aluno.alergias">
                                        <span class="u-mr-10" :key="j" style="text-transform: uppercase;">{{ item.nome }}</span>
                                    </template>
                                </span>

                                <span v-if="aluno.doencas.length > 0">
                                    <b class="u-mr-10">DOENÇAS (S):</b>
                                    <template v-for="(item, m) in aluno.doencas">
                                        <span class="u-mr-10" :key="m" style="text-transform: uppercase;">{{ item.nome }}</span>
                                    </template>
                                </span>
                                <span v-if="aluno.deficiencias.length == 0 && aluno.alergias.length == 0 && aluno.doencas == 0">-</span>
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
            </div>

            <div class="u-text-right u-mb-10" v-if="$store.state.user.tipo == 6">
                <el-button size="small" type="primary" @click="openDialogMatriculaDireta(null)">MATRÍCULA DIRETA</el-button>
            </div>

            <div class="u-text-right u-mb-10">
                <el-button size="mini" @click="openModalMatriculaAee()" title="Matricular aluno em turma AEE" plain style="width: 120px;" class="u-ml-5 u-mr-5">
                    <i class="fab fa-accessible-icon"></i>
                    Matrícula AEE
                </el-button>
                <el-button v-if="[0, 1, 4, 6].includes(Number($store.state.user.tipo))" size="mini" @click="dialogMatriculaComplementar = true" title="Matricular aluno em turma de atividade complementar" plain class="u-ml-5 u-mr-5">
                    <i class="fas fa-palette"></i>
                    Matrícula Atividade Complementar
                </el-button>            
                <el-popover placement="left" class="u-mr-5">
                    <div v-if="loadingPeriodosFrequencia" style="text-align: center;">
                        <img src="/public/img/loading-bar.gif" />
                    </div>
                    <ul v-else class="list-acoes">
                        <template v-if="periodosFrequencia.length > 0">
                            <li @click="openDialogFrequencia(item)" v-for="(item, i) in periodosFrequencia" :key="i">
                                <i class="fas fa-arrow-circle-right"></i>
                                {{ item.periodo_letivo.nome }} ({{ item.contexto }})
                            </li>
                        </template>
                        <template v-else>
                            Nenhum registro
                        </template>
                    </ul>
                    <el-button @click="getPeriodosFrequencia()" slot="reference" title="Mais ações" size="mini" style="width: 120px;" plain>
                        <i class="far fa-calendar-alt"></i>
                        Frequência
                    </el-button>
                </el-popover>
                <el-popover placement="left" class="u-mr-5">
                    <div v-if="loadingPeriodosNota" style="text-align: center;">
                        <img src="/public/img/loading-bar.gif" />
                    </div>
                    <ul v-else class="list-acoes">

                        <template v-if="periodosNota.length > 0">
                            <li @click="openDialogNota(item)" v-for="(item, i) in periodosNota" :key="i">
                                <i class="fas fa-arrow-circle-right"></i>
                                Notas - {{ item.periodo_letivo.nome }} ({{ item.contexto }})
                            </li>
                        </template>
                        <template v-else>
                            Nenhum registro
                        </template>
                    </ul>
                    <el-button @click="getPeriodosNota()" slot="reference" title="Mais ações" size="mini" style="width: 120px;" plain>
                        <i class="fas fa-calculator"></i>
                        Notas
                    </el-button>
                </el-popover>
            </div>
            
            <div class="container-table sem-bordar-header info-detalhe-aluno">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile">Nr. Matrícula</th>
                            <th>Período</th>
                            <th>Instituição</th>
                            <th>Data</th>
                            <th>Curso / Turma</th>
                            <th>Situação Matrícula</th>
                            <th>Situação Acadêmica</th>
                            <th class="u-text-center" style="width: 70px;">Histórico</th>
                            <th class="u-text-center" v-if="$store.state.user.tipo != 10">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in aluno.matriculas" :key="i">
                            <td class="hidden-mobile">{{ item.num_matricula }}</td>
                            <td>
                                <b class="hidden-desktop">PERÍODO LETIVO:</b> {{ item.periodo_letivo.nome }}
                            </td>
                            <td>
                                <a href="javascript:void(0)" title="Visualizar detalhes da matrícula" @click="showDetalhesMatricula(i)">
                                    <b class="hidden-desktop">INSTITUIÇÃO:</b> {{ item.instituicao.nome }}
                                </a>
                            </td>
                            <td>
                                <b class="hidden-desktop">DATA DA MATRÍCULA:</b>{{ (item.data_matricula) ? $moment(item.data_matricula).format('DD/MM/YYYY') : '-' }}
                            </td>
                            <td>
                                <template v-if="item.turma && item.turma.curso_id">
                                    <b class="hidden-desktop">CURSO/TURMA:</b>
                                    <span v-if="item.turma && (item.turma.curso_id == 89 || item.turma.curso_id == 19 || item.turma.curso_id == 18)">
                                        {{ item.curso ? item.curso.nome.toUpperCase() : '-' }} /
                                    </span>
                                    {{ (item.turma && item.turma.curso ? item.turma.curso.nome.toUpperCase() : (item.curso ? item.curso.nome.toUpperCase() : '-')) }}
                                    {{ (item.turma) ? ' / ' + item.turma.nome : '' }}
                                </template>
                            </td>
                            <td>
                                <b class="hidden-desktop">SITUAÇÃO MATRÍCULA:</b> {{ $CONSTANTS.SITUACAO_MATRICULA[item.situacao_matricula] }}
                            </td>
                            <td>
                                <b class="hidden-desktop">SITUAÇÃO ACADÊMICA:</b> {{ (item.situacao_academica) ? $CONSTANTS.SITUACAO_ACADEMICA[item.situacao_academica] : '-' }}
                            </td>
                            <!--
                                ITEM 58 do edital: histórico de inclusões, alterações e
                                movimentações DESTA matrícula. Leitura para todos os perfis
                                que já enxergam o dossiê, inclusive Consulta.
                            -->
                            <td class="u-text-center">
                                <el-button size="mini" plain icon="el-icon-time" title="Ver histórico de alterações desta matrícula"
                                           @click="abrirHistoricoMatricula(item)"></el-button>
                            </td>
                            <td class="u-text-center" style="text-align: center !important;" v-if="$store.state.user.tipo != 10">

                                <el-button disabled title="Aluno vinculado a outra instituição" type="info" icon="el-icon-menu" size="mini" plain v-if="$store.state.user.tipo == 9 || ($store.state.config.instituicao.id != item.instituicao.id && $store.state.user.tipo != 4 && $store.state.user.tipo != 6)"></el-button>

                                <el-popover class="u-ml-10" placement="left" v-if="$store.state.user.tipo != 9 && $store.state.user.tipo != 2 && ($store.state.config.instituicao.id == item.instituicao.id || $store.state.user.tipo == 4 || $store.state.user.tipo == 6)">
                                    <ul class="list-acoes">

                                        <li @click="editarAluno(id)" v-if="
                                            ($store.state.user.tipo <= 1 &&
                                            (item.situacao_matricula == 0 ||
                                             item.situacao_matricula == 1 ||
                                             item.situacao_matricula == 13)) ||
                                             $store.state.user.tipo == 4 ||
                                             $store.state.user.tipo == 6"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Editar Aluno
                                        </li>

                                        <li @click="cancelarMatricula(item.id)" v-if="
                                            (item.situacao_matricula == 1 ||
                                            item.situacao_matricula == 13) &&

                                            ($store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Cancelar Matrícula
                                        </li>

                                        <li @click="setStatusFalecido()" v-if="

                                            (item.situacao_matricula == 1 ||
                                            item.situacao_matricula == 10 ||
                                            item.situacao_matricula == 11) &&

                                            (($store.state.user.tipo == 0 &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"

                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Alterar Status para Falecido
                                        </li>

                                        <li @click="setStatusEvadido(item.id)" v-if="
                                            item.situacao_matricula == 1 &&
                                            ($store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Alterar Status para Evadido
                                        </li>

                                        <li @click="setStatusDesistente(item.id)" v-if="
                                            item.situacao_matricula == 1 &&

                                            (($store.state.user.tipo == 0 &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Alterar Status para Desistente
                                        </li>

                                        <li @click="openModalTransporte(item)" v-if="
                                            (item.situacao_matricula == 0 ||
                                            item.situacao_matricula == 1 ||
                                            item.situacao_matricula == 13) &&
                                            (item.tipo_ensino == 1 || item.tipo_ensino == 2) &&

                                            (($store.state.user.tipo == 0 &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Dados de Transporte
                                        </li>

                                        <li @click="openModalRemanejamento(item)" v-if="
                                            (item.situacao_matricula == 1 ||
                                             item.situacao_matricula == 13) &&

                                            (($store.state.user.tipo <= 1 &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Remanejar para outra Turma
                                        </li>

                                        <li @click="openModalPendenciaHistorico(item)" v-if="
                                            (($store.state.user.tipo <= 1 &&
                                            $store.state.config.instituicao.id == item.instituicao.id))"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Editar pendência de Histórico
                                        </li>
                                        <li @click="concluirAtendimento(item)" v-if="

                                            (item.tipo_ensino == 3 || item.tipo_ensino == 4) && item.situacao_matricula == 1 &&

                                            ((Number($store.state.user.tipo) <= 1 &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            {{ ehReforco(item) ? 'Concluir Matrícula (Objetivo Atingido)' : 'Concluir Matrícula' }}
                                        </li>

                                        <li @click="printAtestadoAluno('objetivo-atingido', item.id)" v-if="

                                            item.tipo_ensino == 4 && item.situacao_matricula == 4 &&
                                            item.curso && $removerAcentos(String(item.curso.nome)).toUpperCase().indexOf('REFORCO') !== -1 &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Declaração de Objetivo Atingido (Reforço)
                                        </li>
                                        <li @click="printRequerimentoMatricula(item.id)" v-if="

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id && 
                                            item.situacao_matricula != 15) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Requerimento de Matrícula
                                        </li>

                                        <li @click="printDeclaracaoMatricula(item.id)" v-if="

                                            item.situacao_matricula == 1 &&
                                            (item.tipo_ensino == 1 || item.tipo_ensino == 2) &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id && 
                                            item.situacao_matricula != 15) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Declaração de Matrícula
                                        </li>

                                        <li @click="printAtestadoAluno('frequencia', item.id)" v-if="

                                            item.situacao_matricula == 1 &&
                                            [1, 2, 3, 4].includes(Number(item.tipo_ensino)) &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Atestado de Frequência
                                        </li>

                                        <li @click="printAtestadoAluno('vaga', item.id)" v-if="

                                            item.situacao_matricula == 1 &&
                                            (item.tipo_ensino == 1 || item.tipo_ensino == 2) &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Atestado de Vaga
                                        </li>

                                        <li @click="printAtestadoAluno('desistencia-vaga', item.id)" v-if="

                                            item.situacao_matricula == 1 &&
                                            (item.tipo_ensino == 1 || item.tipo_ensino == 2) &&
                                            item.turma && item.turma.turno == 4 &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Termo de Desistência de Vaga (Integral)
                                        </li>

                                        <li @click="printAtestadoAluno('termo-adaptacao', item.id)" v-if="

                                            item.situacao_matricula == 1 &&
                                            (item.tipo_ensino == 1 || item.tipo_ensino == 2) &&
                                            item.curso && item.curso.etapa == 0 &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Termo Período de Adaptação
                                        </li>

                                        <li @click="printAtestadoAluno('autorizacao-retirada', item.id)" v-if="

                                            item.situacao_matricula == 1 &&
                                            (item.tipo_ensino == 1 || item.tipo_ensino == 2) &&
                                            item.curso && item.curso.etapa == 0 &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Autorização de Retirada do Aluno
                                        </li>

                                        <li @click="printAtestadoAluno('ficha-inscricao', item.id)" v-if="

                                            (item.tipo_ensino == 3 || item.tipo_ensino == 4) &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Ficha de Inscrição (CIM)
                                        </li>                                       

                                        <li @click="printAtestadoAluno('desistencia', item.id)" v-if="

                                            [1, 11].includes(Number(item.situacao_matricula)) &&
                                            (item.tipo_ensino == 3 || item.tipo_ensino == 4) &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir Termo de Desistência (CIM)
                                        </li>
                                        
                                        <li @click="colocarAlunoTransferencia(item)" v-if="

                                            (
                                                item.situacao_matricula == 0 || 
                                                item.situacao_matricula == 1 ||
                                                item.situacao_matricula == 13 ||
                                                item.situacao_matricula == 10                                                
                                            ) &&
                                            
                                            (($store.state.user.tipo <= 1 &&
                                            $store.state.config.instituicao.id == item.instituicao.id) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"

                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Colocar aluno em transferência
                                        </li>
                                       
                                        <li @click="printAtestadoTransferencia(item)" v-if="

                                            (
                                                item.situacao_matricula == 2 ||
                                                item.situacao_matricula == 10 ||
                                                item.situacao_matricula == 11 ||
                                                
                                                (
                                                    (item.tipo_ensino == 1 || item.tipo_ensino == 2) && item.situacao_matricula == 4 &&
                                                    (item.periodo_letivo_id == $store.state.config.periodo.id || item.periodo_letivo_id == $store.state.config.periodo.periodo_anterior_id)
                                                )
                                            ) &&

                                            (([0, 1, 3, 12].includes(Number($store.state.user.tipo)) &&
                                            $store.state.config.instituicao.id == item.instituicao.id &&
                                            item.situacao_matricula != 15) ||

                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>

                                            Imprimir Atestado de Transferência
                                        </li>

                                        <li @click="printFichaIndividual(item)" v-if="
                                            (
                                                (($store.state.user.tipo <= 1 || $store.state.user.tipo == 3) && $store.state.config.instituicao.id == item.instituicao.id) || 
                                                ($store.state.user.tipo == 6)
                                            )"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Imprimir ficha individual
                                        </li>

                                        <li @click="openFichaSaude(item.aluno_id)" v-if="
                                            (
                                                (($store.state.user.tipo <= 1 || $store.state.user.tipo == 3) && $store.state.config.instituicao.id == item.instituicao.id) ||
                                                ($store.state.user.tipo == 6)
                                            )"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Ficha de Saúde
                                        </li>

                                        <li @click="openSenhaPortal(item.aluno_id, item.num_matricula)" v-if="
                                            (
                                                (($store.state.user.tipo <= 1 || $store.state.user.tipo == 3) && $store.state.config.instituicao.id == item.instituicao.id) ||
                                                ($store.state.user.tipo == 6)
                                            )"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Senha do Portal
                                        </li>

                                        <li style="color: #ff0000;" @click="openDialogMatriculaDireta(item)" v-if="$store.state.user.tipo == 6"
                                        ><i class="fas fa-cogs"></i>
                                            Alterar Matrícula
                                        </li>

                                        <li style="color: #ff0000;" @click="deleteMatricula(item.id)" v-if="$store.state.user.tipo == 6"
                                        ><i class="fas fa-cogs"></i>
                                            Excluir Matrícula
                                        </li>

                                    </ul>
                                    <el-button slot="reference" title="Mais ações" type="primary" icon="el-icon-menu" size="mini" plain></el-button>
                                </el-popover>

                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr v-if="aluno.matriculas.length == 0" style="border-top: 1px solid #ddd;">
                            <td colspan="100%" class="u-text-center">
                                <span>- nenhum registro -</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="u-text-right u-mt-10">
                <el-button type="danger" @click="closeDossie()">FECHAR</el-button>
            </div>
        </div>

        <div v-if="loadingInfoAluno" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-dialog append-to-body :close-on-click-modal="false" title="DADOS DE TRANSPORTE" width="30%" :visible.sync="dialogTransporte">
            <div v-if="dialogTransporte" style="margin-top: 20px;">
                <form-transporte :matricula="matriculaSelected" v-on:onSubmitTransporte="emitFormTransporte"></form-transporte>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="REMANEJAR ALUNO" width="30%" :visible.sync="dialogRemanejar">
            <div v-if="dialogRemanejar" style="margin-top: 20px;">
                <form-remanejamento
                    :propMatriculas="[matriculaSelected.id]"
                    :propInstituicaoId="matriculaSelected.instituicao_id"
                    :propReferenciaNacional="matriculaSelected.referencia_nacional"
                    :propPeriodoLetivoId="matriculaSelected.periodo_letivo_id"
                    v-on:onSubmitRemanejamento="emitFormRemanejamento"
                    :propTipoEnsino="matriculaSelected.tipo_ensino"

                    :propDataNascimento="$moment(aluno.data_nascimento).format('DD/MM/YYYY')"
                    :propAlunoId="aluno.id"

                ></form-remanejamento>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="DETALHES DA MATRÍCULA" width="90%" :visible.sync="dialogDetalhesMatricula" v-on:close="closeDialogDetalhesMatricula">
            <div v-if="dialogDetalhesMatricula">

                <div v-if="Object.keys(matriculaSelected).length !== 0">
                    <el-row :gutter="10" class="u-mt-20">
                        <el-col :xs="24" :sm="16" :md="16">
                            <dl>
                                <dt>ALUNO</dt>
                                <dd>
                                    {{ aluno.nome_social_aluno ? aluno.nome + ' – ' + aluno.nome_social_aluno : aluno.nome }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <dl>
                                <dt>DT. NASCIMENTO</dt>
                                <dd>
                                    {{ (aluno.data_nascimento) ? $moment(aluno.data_nascimento).format('DD/MM/YYYY') : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="16" :md="16">
                            <dl>
                                <dt>INSTITUIÇÃO</dt>
                                <dd>
                                    {{ matriculaSelected.instituicao.nome }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <dl>
                                <dt>PERÍODO</dt>
                                <dd>
                                    {{ matriculaSelected.periodo_letivo.nome }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="matriculaSelected.escola_destino">
                        <el-col :xs="24" :sm="24" :md="24">
                            <dl>
                                <dt>ESCOLA DE DESTINO</dt>
                                <dd>{{ matriculaSelected.escola_destino }}</dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <dl>
                                <dt>CURSO DO ALUNO</dt>
                                <dd>
                                    {{ (matriculaSelected.curso) ? matriculaSelected.curso.nome.toUpperCase() : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <dl>
                                <dt>CURSO DA TURMA</dt>
                                <dd>
                                    {{ (matriculaSelected.turma && matriculaSelected.turma.curso) ? matriculaSelected.turma.curso.nome.toUpperCase() : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <dl>
                                <dt>TURMA</dt>
                                <dd>
                                    {{ (matriculaSelected.turma) ? matriculaSelected.turma.nome.toUpperCase() : '' }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="8">
                            <dl>
                                <dt>DT. MATRÍCULA</dt>
                                <dd>
                                    {{ (matriculaSelected.data_matricula) ? $moment(matriculaSelected.data_matricula).format('DD/MM/YYYY HH:mm') : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="matriculaSelected.nome_ultima_escola == $store.state.config.instituicao.nome || matriculaSelected.instituicao_id == $store.state.config.instituicao.id || $store.state.user.tipo == 4 || $store.state.user.tipo == 6 ? 8 : 16">
                            <dl>
                                <dt style="width: 140px;">DT. TRANSFERÊNCIA</dt>
                                <dd>
                                    {{ (matriculaSelected.data_transferencia) ? $moment(matriculaSelected.data_transferencia).format('DD/MM/YYYY') : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" v-if="
                            matriculaSelected.nome_ultima_escola == $store.state.config.instituicao.nome || matriculaSelected.instituicao_id == $store.state.config.instituicao.id || $store.state.user.tipo == 4 || $store.state.user.tipo == 6
                        ">
                            <dl>
                                <dt style="width: 150px;">COD. TRANSFERÊNCIA</dt>
                                <dd>
                                    {{ matriculaSelected.cod_transferencia }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <dl>
                                <dt>TRANSPORTE</dt>
                                <dd>
                                    <span style="text-transform: uppercase">{{ (matriculaSelected.tipo_transporte) ? matriculaSelected.tipo_transporte.nome : 'NÃO' }}</span>
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <dl>
                                <dt>ROTA</dt>
                                <dd>
                                    <span style="text-transform: uppercase">{{ (matriculaSelected.rota) ? matriculaSelected.rota : '-' }}</span>
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <dl>
                                <dt>ST. MATRÍCULA</dt>
                                <dd>
                                    {{ $CONSTANTS.SITUACAO_MATRICULA[matriculaSelected.situacao_matricula] }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <dl>
                                <dt>ST. ACADÊMICA</dt>
                                <dd>
                                    {{ (matriculaSelected.situacao_academica || matriculaSelected.situacao_academica == 0) ? $CONSTANTS.SITUACAO_ACADEMICA[matriculaSelected.situacao_academica] : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="matriculaSelected.motivo_cancelamento">
                        <el-col :xs="24" :sm="24" :md="24">
                            <dl>
                                <dt>MOTIVO DO CANCELAMENTO</dt>
                                <dd>
                                    {{ matriculaSelected.motivo_cancelamento }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <dl>
                                <dt>OBSERVAÇÃO</dt>
                                <dd>
                                    {{ (matriculaSelected.observacao) ? matriculaSelected.observacao : '-' }}
                                </dd>
                            </dl>
                        </el-col>
                    </el-row>
                    <div class="u-text-right u-mt-20">
                        <el-button type="danger" @click="dialogDetalhesMatricula = false">FECHAR</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="MATRÍCULA EM ATIVIDADE COMPLEMENTAR" :visible.sync="dialogMatriculaComplementar">
            <div v-if="dialogMatriculaComplementar" style="margin-top: 20px;">
                <form-matricula-aee :aluno="aluno" complementar v-on:onSubmitMatriculaAee="emitFormMatriculaComplementar"></form-matricula-aee>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="MATRÍCULA EM ATENDIMENTO EDUCACIONAL ESPECIALIZADO" :visible.sync="dialogMatriculaAee">
            <div v-if="dialogMatriculaAee" style="margin-top: 20px;">
                <form-matricula-aee :aluno="aluno" v-on:onSubmitMatriculaAee="emitFormMatriculaAee"></form-matricula-aee>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" :show-close="false" :modal-append-to-body="false" title="DECLARAÇÃO" width="80%" :visible.sync="dialogTextoDeclaracao">
            <div v-if="dialogTextoDeclaracao" style="margin-top: 20px;">
                <texto-declaracao :matricula="matriculaSelected.id" v-on:closeModal="closeModalTextoDeclaracao"></texto-declaracao>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" top="5vh" title="MATRÍCULA DIRETA" :visible.sync="dialogFormMatriculaDireta" v-on:close="closeDialogFormMatriculaDireta">
            <div v-if="dialogFormMatriculaDireta" style="margin-top: 20px;">
                <form-matricula-direta :aluno="aluno" :matricula="matriculaSelected" v-on:onSubmitMatriculaDireta="emitFormMatriculaDireta"></form-matricula-direta>
            </div>
        </el-dialog>
        
        <el-dialog append-to-body :close-on-click-modal="false" title="EDITAR PENDÊNCIA DE HISTÓRICO" width="30%" :visible.sync="dialogPendenciaHistorico">
            <div v-if="dialogPendenciaHistorico" style="margin-top: 20px;">
                <editarPendenciaDialog 
                    :visible.sync="dialogPendenciaHistorico"
                    :matPendHistorico="this.matPendHistorico"
                    :formPendencia="formPendencia"
                    v-on:onSubmit="emitFormPendencia"
                    
                />
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="70%" :title="`${ aluno.nome_social_aluno ? aluno.nome_social_aluno +' – '+ aluno.nome : aluno.nome} - ${$moment(aluno.data_nascimento).format('DD/MM/YYYY')}`" :visible.sync="dialogFrequencia">
            <div v-if="dialogFrequencia" style="margin-top: 20px;">
                <frequencia :id="frequenciaSelected.id" :turma_id="frequenciaSelected.turma_id" :aluno_id="frequenciaSelected.aluno_id" @close="closeDialogFrequencia"></frequencia>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" :title="`${aluno.nome_social_aluno ? aluno.nome_social_aluno +' – '+ aluno.nome : aluno.nome} - ${$moment(aluno.data_nascimento).format('DD/MM/YYYY')}`" :visible.sync="dialogNota">
            <div v-if="dialogNota" style="margin-top: 20px;">
                <nota :id="notaSelected.id" :turma_id="notaSelected.turma_id" :aluno_id="notaSelected.aluno_id" @close="closeDialogNota"></nota>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" title="SENHA DO PORTAL DO ALUNO" width="440px" :visible.sync="dialogSenhaPortal">
            <div v-if="dialogSenhaPortal" v-loading="loadingSenhaPortal" style="margin-top: 10px;">
                <el-form label-position="top">
                    <el-form-item label="Número da matrícula (usuário de acesso)">
                        <el-input :value="senhaPortalForm.num_matricula" readonly></el-input>
                    </el-form-item>
                    <el-form-item class="u-mt-10" label="Senha (acesso do aluno ao portal)">
                        <el-input v-model="senhaPortalForm.psw" maxlength="191" placeholder="Informe a senha">
                            <template slot="append">
                                <el-button @click="copiarSenhaPortal" title="Copiar"><i class="el-icon-document-copy"></i></el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="u-text-right u-mt-10">
                    <el-button @click="dialogSenhaPortal = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" :loading="loadingSenhaPortal" @click="salvarSenhaPortal">SALVAR</el-button>
                </div>
            </div>
        </el-dialog>


        <!-- ITEM 58 — histórico de alterações de uma matrícula -->
        <el-dialog title="Histórico da matrícula" :visible.sync="dialogHistoricoMatricula" width="70%" append-to-body>
            <div v-loading="loadingHistoricoMatricula">
                <p v-if="historicoMatriculaRef" class="hist-ref">
                    Matrícula <strong>{{ historicoMatriculaRef.num_matricula || historicoMatriculaRef.id }}</strong>
                    <span v-if="historicoMatriculaRef.instituicao"> · {{ historicoMatriculaRef.instituicao.nome }}</span>
                    <span v-if="historicoMatriculaRef.periodo_letivo"> · {{ historicoMatriculaRef.periodo_letivo.nome }}</span>
                </p>

                <p v-if="!loadingHistoricoMatricula && !historicoMatricula.length" class="hist-vazio">
                    Nenhuma alteração registrada para esta matrícula.
                </p>

                <el-timeline v-else>
                    <el-timeline-item v-for="h in historicoMatricula" :key="h.id"
                        :timestamp="$moment(h.created_at).format('DD/MM/YYYY HH:mm')" placement="top"
                        :type="corEventoHistorico(h.event)">
                        <el-card shadow="never">
                            <p class="hist-cab">
                                <el-tag size="mini" :type="corEventoHistorico(h.event)">{{ rotuloEventoHistorico(h.event) }}</el-tag>
                                <span class="hist-user">{{ h.user ? h.user.name : 'sistema' }}</span>
                            </p>
                            <div v-if="camposAlterados(h).length" class="container-table">
                                <table class="table">
                                    <thead>
                                        <tr><th style="width: 34%;">Campo</th><th style="width: 33%;">De</th><th style="width: 33%;">Para</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="c in camposAlterados(h)" :key="c.campo">
                                            <td>{{ c.campo }}</td>
                                            <td class="hist-de">{{ c.de }}</td>
                                            <td class="hist-para">{{ c.para }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p v-else class="hist-vazio">Sem detalhamento de campos neste registro.</p>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>
        
        <!-- <div class="u-mt-20" v-if="aluno && aluno.id">
            <documentos-da-origem origem-tipo="aluno" :origem-id="aluno.id"
                                  titulo="Documentos do aluno"></documentos-da-origem>
        </div> -->

    </div>
</template>
<script>

import documentosDaOrigem from '@/shared/documentos-da-origem/documentos-da-origem.vue'
import formTransporte from '@/components/transporte'
import formRemanejamento from '@/components/matricula/remanejamento'
import formMatriculaAee from '@/components/matricula/form-aee'
import textoDeclaracao from '@/components/matricula/transferencia/texto-declaracao'
import formMatriculaDireta from '@/components/matricula/form-matricula-direta'
import frequencia from '@/components/diario/frequencia/info'
import nota from '@/components/diario/nota/info'
import editarPendenciaDialog from '@/components/pendencia-historico/EditarPendenciaDialog/'

export default {
    props: ['id'],
    data: () => ({
        periodosFrequencia: [],
        loadingPeriodosFrequencia: false,
        periodosNota: [],
        loadingPeriodosNota: false,
        aluno: {},
        loadingInfoAluno: false,
        matriculaSelected: {},
        frequenciaSelected: {},
        notaSelected: {},
        dialogFormMatriculaDireta: false,
        dialogTransporte: false,
        dialogRemanejar: false,
        dialogDetalhesMatricula: false,
        dialogHistoricoMatricula: false,
        loadingHistoricoMatricula: false,
        historicoMatricula: [],
        historicoMatriculaRef: null,
        dialogMatriculaAee: false,
        dialogMatriculaComplementar: false,
        dialogTextoDeclaracao: false,
        dialogFrequencia: false,
        dialogNota: false,
        dialogPendenciaHistorico: false,
        formPendencia: {},
        matPendHistorico: '',
        dialogSenhaPortal: false,
        loadingSenhaPortal: false,
        senhaPortalForm: { aluno_id: null, num_matricula: '', psw: '', token: '' }
    }),
    mounted () { },
    methods: {
        /**
         * ITEM 58 — carrega o histórico desta matrícula.
         *
         * O endpoint recebe a classe do model URL-encoded; o backend faz `urldecode`.
         */
        abrirHistoricoMatricula (matricula) {
            this.historicoMatriculaRef = matricula
            this.historicoMatricula = []
            this.dialogHistoricoMatricula = true
            this.loadingHistoricoMatricula = true

            const tipo = encodeURIComponent('App\\Models\\Matricula')

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/audit/historicoDe/${tipo}/${matricula.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.loadingHistoricoMatricula = false
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: (r.data.erro.text || r.data.erro), type: 'warning' })
                    return
                }
                this.historicoMatricula = Array.isArray(r.data) ? r.data : []
            }).catch(e => {
                this.loadingHistoricoMatricula = false
                this.$store.commit('throwException', e)
            })
        },
        /** Compara o antes e o depois, listando só o que mudou de fato. */
        camposAlterados (h) {
            const antigo = this.objetoDoAudit(h.old_values)
            const novo = this.objetoDoAudit(h.new_values)
            const chaves = Object.keys(Object.assign({}, antigo, novo))
            const saida = []

            chaves.forEach(k => {
                if (['updated_at', 'created_at'].indexOf(k) !== -1) return
                const de = antigo[k]
                const para = novo[k]
                if (JSON.stringify(de) === JSON.stringify(para)) return
                saida.push({ campo: k, de: this.valorHistorico(de), para: this.valorHistorico(para) })
            })

            return saida
        },
        objetoDoAudit (v) {
            if (!v) return {}
            if (typeof v === 'string') { try { return JSON.parse(v) || {} } catch (e) { return {} } }
            return v
        },
        valorHistorico (v) {
            if (v === null || v === undefined || v === '') return '—'
            if (typeof v === 'object') return JSON.stringify(v)
            return String(v)
        },
        rotuloEventoHistorico (e) {
            const m = { created: 'INCLUSÃO', updated: 'ALTERAÇÃO', deleted: 'EXCLUSÃO', restored: 'RESTAURAÇÃO' }
            return m[e] || String(e || '').toUpperCase()
        },
        corEventoHistorico (e) {
            const m = { created: 'success', updated: 'warning', deleted: 'danger', restored: 'info' }
            return m[e] || 'info'
        },
        printFichaIndividual(item) {

            window.eventBus.$emit('print', {url: '/api/pdf/renderFichaIndividual', param: item.id});
        },
        getPeriodosFrequencia(){
            let i = this.$store.state.config.instituicao.id;
            this.loadingPeriodosFrequencia = true;
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia/getPeriodosFrequencia/${this.aluno.id}/${i}`, this.$store.getters.getHeaderAuth).then(response => {
                this.periodosFrequencia = response.data;
                this.loadingPeriodosFrequencia = false;
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        getPeriodosNota(){
            let i = this.$store.state.config.instituicao.id;
            this.loadingPeriodosNota = true;
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/nota/getPeriodosNota/${this.aluno.id}/${i}`, this.$store.getters.getHeaderAuth).then(response => {
                this.periodosNota = response.data;
                this.loadingPeriodosNota = false;
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        openDialogFrequencia(item){
            this.frequenciaSelected = item;
            this.dialogFrequencia = true;           
        },
        closeDialogFrequencia(){
            this.dialogFrequencia = false;
        },
        openDialogNota(item){
            this.notaSelected = item;
            this.dialogNota = true;           
        },
        closeDialogNota(){
            this.dialogNota = false;
        },
        emitFormMatriculaDireta(){

            this.dialogFormMatriculaDireta = false;
            this.$emit('changeDossie', { loading: true, close: false });
            this.getAluno(this.aluno.id);
        },
        openDialogMatriculaDireta(item){

            if(item){

                this.matriculaSelected = item;
            }

            this.dialogFormMatriculaDireta = true;
        },
        closeDialogFormMatriculaDireta(){

            this.dialogFormMatriculaDireta = false;
            this.matriculaSelected = {};
        },
        deleteMatricula(id){

            this.$msgbox.confirm('Atenção! A matrícula será removida permanentemente do banco de dados. Tem certeza que deseja excluir esta matrícula?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/matricula/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$emit('changeDossie', { loading: true, close: false });
                    this.getAluno(this.aluno.id);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        setStatusEvadido(matricula_id){

            this.$msgbox.confirm('Tem certeza que deseja mudar o status deste aluno para evadido?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/updateStatusForEvadido/${matricula_id}`, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('changeDossie', { loading: true, close: false });
                        this.getAluno(this.aluno.id);

                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        setStatusDesistente(matricula_id){

            this.$msgbox.confirm('Tem certeza que deseja mudar o status deste aluno para desistente?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/updateStatusForDesistente/${matricula_id}`, this.$store.getters.getHeaderAuth).then(response => {


                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('changeDossie', { loading: true, close: false });
                        this.getAluno(this.aluno.id);
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        setStatusFalecido(){

            this.$msgbox.confirm('Tem certeza que deseja mudar o status do aluno para falecido? Essa ação será irreversível.', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/updateStatusForFalecido/${this.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$emit('changeDossie', { loading: true, close: false });
                    this.getAluno(this.aluno.id);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        getAluno(id){

            this.loadingInfoAluno = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/getByIdForInfo/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.aluno = response.data;
                this.loadingInfoAluno = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        editarAluno(item){

            this.$router.push('/admin/aluno/edit/'+ item);
        },
        colocarAlunoTransferencia(matricula){

            this.$prompt(`Para qual escola o aluno ${matricula.nome_aluno} vai estudar?`, 'Colocar aluno em transferência', {
                confirmButtonText: 'Colocar em transferência',
                cancelButtonText: 'Cancelar',
                inputPlaceholder: 'Nome da escola de destino',
                inputValidator: (v) => !!(v && v.trim()) || 'Informe a escola de destino.'
            }).then(({ value }) => {

                window.eventBus.$emit('loading', true);

                let p = this.$store.state.config.periodo.id;

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/storeTransferencia/${p}/0/${matricula.id}`, { escola_destino: value }, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        this.$alert(response.data.throw.msg, 'Atenção', {
                            confirmButtonText: 'OK',
                            type: response.data.throw.type,
                            center: true
                        }).catch(()=>{});

                    }else{

                        if([1, 2, 5].includes(Number(matricula.tipo_ensino))) {
                            this.matriculaSelected = response.data;
                            this.dialogTextoDeclaracao = true;                            
                        }

                        this.$emit('changeDossie', { loading: true, close: false });
                        this.getAluno(this.id);
                    }

                    window.eventBus.$emit('loading', false);
                });

            }).catch(()=>{});
        },
        closeModalTextoDeclaracao(){

            this.matriculaSelected = {};
            this.dialogTextoDeclaracao = false;
        },
        printDeclaracaoMatricula(id){

            window.eventBus.$emit('print', {url: '/api/pdf/renderDeclaracaoMatricula', param: id });
        },
        ehReforco(item){

            return item.tipo_ensino == 4 && !!item.curso && this.$removerAcentos(String(item.curso.nome)).toUpperCase().indexOf('REFORCO') !== -1;
        },
        // AEE (multifuncional) e atividade complementar: conclui a matrícula. No Reforço Escolar a
        // conclusão é por objetivo atingido e já emite a declaração.
        concluirAtendimento(item){

            const reforco = this.ehReforco(item);
            const msg = reforco
                ? 'Confirma que o aluno atingiu o objetivo do Reforço Escolar? A matrícula de reforço será concluída e a declaração de objetivo atingido será emitida.'
                : `Confirma a conclusão da matrícula ${item.tipo_ensino == 3 ? 'de AEE' : 'de atividade complementar'}${item.turma ? ' (' + item.turma.nome + ')' : ''}? A matrícula passará para CONCLUÍDA.`;

            this.$msgbox.confirm(msg, 'Atenção', { confirmButtonText: 'Sim, concluir', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/concluirAtendimento/${item.id}`, {}, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);

                    if(response.data && response.data.erro){
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        return;
                    }

                    window.eventBus.$emit('alert', {msg: 'Matrícula concluída.', type: 'success'});
                    if (response.data.reforco) this.printAtestadoAluno('objetivo-atingido', item.id);
                    this.$emit('changeDossie', { loading: true, close: false });
                    this.getAluno(this.aluno.id);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(() => {});
        },
        printAtestadoAluno(documento, id){

            window.eventBus.$emit('print', {url: '/api/pdf/renderAtestadoAluno/' + documento, param: id });
        },
        openModalMatriculaAee(){

            this.dialogMatriculaAee = true;
        },
        emitFormMatriculaAee(){

            this.dialogMatriculaAee = false;
            this.getAluno(this.id);
        },
        emitFormMatriculaComplementar(){

            this.dialogMatriculaComplementar = false;
            this.getAluno(this.id);
        },
        showDetalhesMatricula(i){

            this.dialogDetalhesMatricula = true;
            this.matriculaSelected = this.aluno.matriculas[i];
        },
        printRequerimentoMatricula(id){

            window.eventBus.$emit('print', {url: '/api/pdf/renderRequerimentoMatricula', param: id});
        },
        printAtestadoTransferencia(matricula){

            this.matriculaSelected = matricula;
            this.dialogTextoDeclaracao = true;
        },
        openModalTransporte(matricula){

            this.matriculaSelected = matricula;
            this.dialogTransporte = true
        },
        emitFormTransporte(){

            this.dialogTransporte = false
            this.getAluno(this.id);
            this.matriculaSelected = {};

        },
        openModalRemanejamento(matricula){

            this.matriculaSelected = matricula;
            this.dialogRemanejar = true;
        },
        emitFormRemanejamento(){

            this.dialogRemanejar = false;
            this.getAluno(this.id);
            this.matriculaSelected = {};
        },
        openModalPendenciaHistorico(item){            
            
            this.matPendHistorico = item.historico_pendente;            
                       
            this.formPendencia.id_aluno = item.id_aluno
            this.formPendencia.id_matricula = item.id
            this.formPendencia.nome = item.nome_aluno
            this.formPendencia.num_matricula = item.num_matricula
            this.formPendencia.situacao_matricula = item.situacao_matricula
            this.dialogPendenciaHistorico = true;
        },
        emitFormPendencia(){
            this.dialogPendenciaHistorico = false;            
            this.matPendHistorico = '';
            this.closeDossie();
            
        },
        cancelarMatricula(id){

            this.$prompt('Informe o motivo do cancelamento da matrícula:', 'Cancelar Matrícula', {
                confirmButtonText: 'Confirmar cancelamento',
                cancelButtonText: 'Voltar',
                inputType: 'textarea',
                inputPlaceholder: 'Descreva o motivo do cancelamento...',
                inputValidator: (v) => (v && v.trim().length > 0) ? true : 'Informe o motivo do cancelamento.',
                type: 'warning'
            }).then(({ value }) => {

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/cancelarMatricula/` + id, { motivo: value }, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getAluno(this.id);
                        this.$emit('changeDossie', { loading: true, close: false });
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        closeDossie(){

            this.$emit('changeDossie', { loading: false, close: true });
        },
        closeDialogDetalhesMatricula(){

            this.matriculaSelected = {};
        },
        openFichaSaude(id){
            this.$router.push(`/admin/aluno/ficha-saude/${id}`);
        },
        openSenhaPortal(alunoId, numMatricula){
            this.senhaPortalForm = { aluno_id: alunoId, num_matricula: numMatricula, psw: '', token: '' };
            this.dialogSenhaPortal = true;
            this.loadingSenhaPortal = true;
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/getSenhaPortal/${alunoId}`, this.$store.getters.getHeaderAuth).then(response => {
                this.loadingSenhaPortal = false;
                if(response.data && response.data.erro){
                    window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' });
                    this.dialogSenhaPortal = false;
                    return;
                }
                this.senhaPortalForm.psw = response.data.psw;
                this.senhaPortalForm.token = response.data.token;
            }).catch(error => { this.loadingSenhaPortal = false; this.$store.commit('throwException', error); });
        },
        salvarSenhaPortal(){
            if(!this.senhaPortalForm.psw || !this.senhaPortalForm.psw.trim()){
                window.eventBus.$emit('alert', { msg: 'Informe a senha.', type: 'warning' });
                return;
            }
            this.loadingSenhaPortal = true;
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/updateSenhaPortal/${this.senhaPortalForm.aluno_id}`, { psw: this.senhaPortalForm.psw }, this.$store.getters.getHeaderAuth).then(response => {
                this.loadingSenhaPortal = false;
                if(response.data && response.data.erro){
                    window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' });
                    return;
                }
                window.eventBus.$emit('alert', { msg: 'Senha atualizada com sucesso.', type: 'success' });
                this.dialogSenhaPortal = false;
            }).catch(error => { this.loadingSenhaPortal = false; this.$store.commit('throwException', error); });
        },
        copiarSenhaPortal(){
            const el = document.createElement('textarea');
            el.value = this.senhaPortalForm.psw || '';
            document.body.appendChild(el);
            el.select();
            try { document.execCommand('copy'); window.eventBus.$emit('alert', { msg: 'Senha copiada.', type: 'success' }); } catch (e) { /* ignore */ }
            document.body.removeChild(el);
        }
    },
    watch: {
        id: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getAluno(value);
                }
            }
        }
    },
    components:{ textoDeclaracao, formTransporte, formRemanejamento, formMatriculaAee, formMatriculaDireta, frequencia, nota, editarPendenciaDialog, documentosDaOrigem }
}
</script>
<style scoped>
/* ITEM 58 — histórico da matrícula */
.hist-ref { font-size: 12px; color: #606266; margin-bottom: 10px; }
.hist-vazio { color: #909399; font-size: 12px; }
.hist-cab { margin: 0 0 8px; }
.hist-user { margin-left: 8px; font-size: 11px; color: #909399; }
.hist-de { color: #f56c6c; }
.hist-para { color: #67c23a; }
</style>
